// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QMWXS","nameDescriptionContainer":"styles_nameDescriptionContainer__DgBVL","name":"styles_name__5ExUr","description":"styles_description__2aUZl"};